import { DropResult } from 'react-beautiful-dnd';
import { TTeamMemberType } from '../../../Roles/RoleModal/models/RoleAssignmentModel';
import { NTeamManager } from './interfaces';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
// const reorder = (list: any[], startIndex: number, endIndex: number) => {
// 	const result = Array.from(list);
// 	const [removed] = result.splice(startIndex, 1);
// 	result.splice(endIndex, 0, removed);

// 	return result;
// };

export const markTerminatedUsers = (users: NTeamManager.User[]) => {
  const activeUsers: NTeamManager.User[] = [];

  users.forEach((user) => {
    if (user.isActive) {
      activeUsers.push(user);
    }
  });

  const comparator = (u1: NTeamManager.User, u2: NTeamManager.User) => (u1.userName < u2.userName ? 1 : -1);

  return [...activeUsers.sort(comparator)];
};

export const onTeamManagerDragEnd = (
  result: DropResult,
  visibleAgents: NTeamManager.User[],
  teamManager: NTeamManager.Response,
  setTeamManager: (teamManager: NTeamManager.Response) => void
) => {
  const data: NTeamManager.Response = JSON.parse(JSON.stringify(teamManager));

  const { source, destination } = result;

  if (!destination || source.droppableId === destination.droppableId) {
    return;
  }

  let sourceAgent: NTeamManager.User;
  let teams = Array.from(data.teams);
  let unassignedUsers = Array.from(data.unassignedUsers);

  const isUnassignedSourceAgent = source.droppableId === 'unassigned';
  const isUnassignedListTarget = destination.droppableId === 'unassigned';

  const [sourceTeamIndex, sourceRoleType] = source.droppableId?.split('_') as [string, TTeamMemberType];
  const [destinationTeamIndex, destinationRoleType] = destination.droppableId?.split('_') as [string, TTeamMemberType];

  if (isUnassignedSourceAgent) {
    sourceAgent = visibleAgents[source.index];
    unassignedUsers = data.unassignedUsers.filter(({ userId }) => userId !== sourceAgent.userId);
  } else {
    const sourceTeam = data.teams[Number(sourceTeamIndex)];
    sourceAgent = sourceTeam?.roleUsers?.[sourceRoleType]?.[source.index];
  }

  if (isUnassignedListTarget) {
    unassignedUsers.splice(destination.index, 0, sourceAgent);
  }

  teams = teams.map((team, index) => {
    if (index === Number(sourceTeamIndex)) {
      team.roleUsers[sourceRoleType] = team.roleUsers[sourceRoleType].filter((user) => user.userId !== sourceAgent.userId);
      team.users = team.users.filter((user) => user.userId !== sourceAgent.userId);
    }

    if (index === Number(destinationTeamIndex)) {
      sourceAgent.teamMemberType = destinationRoleType;
      team.roleUsers[destinationRoleType].splice(destination.index, 0, sourceAgent);
      team.users.push(sourceAgent);
    }

    return team;
  });

  setTeamManager({
    ...teamManager,
    unassignedUsers,
    teams,
  });
};
